import React, { Fragment, useEffect, useState } from "react";
import {
	showToast,
	TOAST_TYPE,
	DKIcons,
	DKInput,
	DKIcon,
	DKButton,
	INPUT_VIEW_DIRECTION,
	DKLabel,
	DKRadioButton,
} from "deskera-ui-library";
import { FORMAT, INPUT_TYPE } from "../../constants/Constant";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import { useSelector } from "react-redux";
import { selectEmployee } from "../../Redux/Slices/EmployeeListSlice";
import moment from "moment";
import { DATE_FORMAT } from "../../constants/Constant";
import EmployeeListService from "../../services/EmployeeListService";
import Table from "../../services/table";
import Utility from "../../utility/Utility";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { INTERVIEW_FEEDBACK_OPTIONS, TERMINATION_REASONS, TERMINATION_TYPE } from "./employeeConstants";

const EmployteeTermination = (props) => {
	const customFieldSectionEnabled = TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED);

	const employeeData = useSelector(selectEmployee);
	const { users } = employeeData;
	const [selectedEmplyee, setSelectedEmployee] = useState({});
	const [checkList, setCheckList] = useState([]);
	const [prevStateData, setPrevStateData] = useState({});

	const [detailObj, setDetailObj] = useState({
		compliance: [],
		empNameFormControl: "",
		employeeId: "",
		employeePersonalEmail: "",
		fieldValue: false,
		terminationDate: "",
		terminationReason: "",
		terminationType: "VOLUNTARY"
	});

	const [formValidation, setFormValidation] = useState({
		terminationDate: {
			isInvalid: false,
			errorMsg: customFieldSectionEnabled ? "Select a termination date" : "Select a employee's last day",
		},
		dateOfTermination: {
			isInvalid: false,
			errorMsg: "Select a date of termination",
		},
		terminationReason: {
			isInvalid: false,
			errorMsg: customFieldSectionEnabled ? "Select a termination reason" : "Enter a termination reason",
		},
		employeePersonalEmail: {
			isInvalid: false,
			errorMsg: "Enter a valid email",
		},
	});

	useEffect(() => {
		const prevState = props.state && props.state.detailObj ? props.state.detailObj : {};
		const prevStateDetailList = props.state && props.state.checkList ? props.state.checkList : {};
		if (users) {
			users.forEach((user) => {
				if (user.userId == props.userId) {
					setSelectedEmployee(user);
					if (props.state.currentStep === 1 && Object.keys(prevStateDetailList).length === 0) {
						getCheckList(user);
					} else if (props.state.currentStep === 1 && Object.keys(prevStateDetailList).length !== 0) {
						setCheckList(prevStateDetailList);
					}
					setTerminationType("VOLUNTARY", user);
					if (user.terminationStage === "termination_initiated" && props.state.currentStep === 0 && Object.keys(prevState).length === 0) {
						getTermination(user);
					} else if (props.state.currentStep === 0 && Object.keys(prevState).length !== 0) {
						setDetailObj(prevState);
					}
				}
			});
			setPrevStateData(prevState);
		} else {
			RouteManager.navigateToPage(PAGE_ROUTES.EMPLOYEE_LIST);
		}
	}, []);

	useEffect(() => {
		if (props.state.currentStep === 1) {
			let prevState = props.state && props.state.detailObj ? props.state.detailObj : {};
			props.setData({
				...props.setData,
				detailObj: prevState,
			});
		} else {
			props.setData({
				...props.state,
				detailObj: detailObj,
			});
		}
	}, [detailObj]);

	useEffect(() => {
		if (props.state.currentStep === 1) {
			props.setData({
				...props.state,
				checkList: checkList,
			});
		}
	}, [checkList]);
	useEffect(() => {
		if (props.checkValid) {
			isValidate();
		}
	}, [props.checkValid]);

	const getTimePeriod = (start) => {
		let terminationDate = start ? `${moment(start).format(DATE_FORMAT.IND)}` : "";
		setDetailObj({
			...detailObj,
			terminationDate: terminationDate,
		});
	};

	const getCheckList = async (user) => {
		try {
			Table.getCheckList(parseInt(user["iamUserId"])).then((data) => {
				if (customFieldSectionEnabled && Array.isArray(data)) {
					setCheckList(data.filter(item => !Utility.isEmpty(item.id)));
				} else {
					setCheckList(data);
				}
			});
		} catch (err) {
			showToast("Error fetching checklist: ", TOAST_TYPE.FAILURE);
		}
	};

	const getTermination = async (user) => {
		try {
			Table.getTermination(parseInt(user["iamUserId"])).then((data) => {
				setDetailObj(data);
				return data;
			});
		} catch (err) {
			showToast("Error fetching termination: ", TOAST_TYPE.FAILURE);
		}
	};

	const onChangeOfCheckList = (seq, value) => {
		let checkListArray = checkList.slice();
		checkListArray.forEach((obj) => {
			if (obj.seq === seq + 1) {
				checkListArray[seq]["item"] = value;
			}
		});
		setCheckList(checkListArray);
	};

	const showCheckList = () => {
		let a;
		checkList.sort(compare);
		if (checkList && checkList.length > 0) {
			{
				a = checkList.map((list, index) => {
					return (
						<div className="justify-content-between row mb-m parent-width">
							<DKInput
								type={INPUT_TYPE.TEXT}
								value={list.item}
								direction={INPUT_VIEW_DIRECTION.VERTICAL}
								required
								onChange={(e) => {
									onChangeOfCheckList(index, e);
								}}
							/>
							<div onClick={() => deleteChecklist(index)} style={{ opacity: "0.6" }}>
								<DKIcon
									src={DKIcons.ic_delete}
									className="ic-s-2 ml-m"
									style={{ opacity: 0.8 }}
								/>
							</div>
						</div>
					);
				});
			}
		}
		return a;
	};

	const compare = (a, b) => {
		if (parseInt(a.seq) < parseInt(b.seq)) {
			return -1;
		}
		if (parseInt(a.seq) > parseInt(b.seq)) {
			return 1;
		}
		return 0;
	};

	const addChecklist = () => {
		const checkListObj = {
			item: " ",
			seq: checkList.length + 1,
		};
		const checkListArray = checkList.slice();
		checkListArray.push(checkListObj);
		setCheckList(checkListArray);
	};

	const deleteChecklist = (index) => {
		let checkListArray = checkList.slice();
		checkListArray.splice(index, 1);
		setCheckList(checkListArray);
	};

	const setTerminationType = (type, user) => {
		setDetailObj({
			...detailObj,
			compliance: [
				{
					fieldName: "IR21",
					fieldValue: user.address && user.country == "SG",
				},
			],
			terminationType: type,
			employeeId: user["iamUserId"],
			employeePersonalEmail: user["emailId"],
			empNameFormControl: user["firstName"] + " " + user["lastName"],
		});
	};

	const showError = (msg) => {
		return <div className="text-red text-align-left fs-r">{msg}</div>;
	};

	const isValidate = () => {
		let fieldsToValid = ["employeePersonalEmail", "terminationDate", "terminationReason"];
        if (customFieldSectionEnabled) {
            fieldsToValid = ["dateOfTermination", "employeePersonalEmail", "terminationDate", "terminationReason"];
        }

		fieldsToValid.forEach((field) => {
			onChange(detailObj[field], field);
		});
	};

	const onChange = (value, field) => {
		switch (field) {
			case "employeePersonalEmail":
				if (value.trim() == "") {
					setFormValidation({
						...formValidation,
						employeePersonalEmail: {
							isInvalid: true,
							errorMsg: formValidation.employeePersonalEmail.errorMsg,
						},
					});
				} else if (!Utility.isValidEmail(value)) {
					setFormValidation({
						...formValidation,
						employeePersonalEmail: {
							isInvalid: true,
							errorMsg: formValidation.employeePersonalEmail.errorMsg,
						},
					});
				} else {
					setFormValidation({
						...formValidation,
						employeePersonalEmail: {
							isInvalid: false,
							errorMsg: formValidation.employeePersonalEmail.errorMsg,
						},
					});
				}
				break;
            case "terminationDate":
                if (Utility.isEmpty(value)) {
                    formValidation[field].isInvalid = true;
					const fieldName = customFieldSectionEnabled ? "termination date" : "employee's last day";
                    formValidation[field].errorMsg = `Select a ${fieldName}`;
                } else if (value instanceof Date && new Date(selectedEmplyee.dateOfJoining).getTime() > value.getTime()) {
                    formValidation[field].isInvalid = true;
					const fieldName = customFieldSectionEnabled ? "Termination date" : "Employee's last day";
                    formValidation[field].errorMsg = `${fieldName} should be gretaer than date of joining`;
                } else {
                    formValidation[field].isInvalid = false;
                }
                break;
            case "dateOfTermination":
                if (Utility.isEmpty(value)) {
                    formValidation[field].isInvalid = true;
                    formValidation[field].errorMsg = "Select a date of termination";
                } else if (value instanceof Date && new Date(selectedEmplyee.dateOfJoining).getTime() > value.getTime()) {
                    formValidation[field].isInvalid = true;
                    formValidation[field].errorMsg = "Date of termination should be gretaer than date of joining";
                } else {
                    formValidation[field].isInvalid = false;
                }
                break;
			default:
				if (typeof value === "string" && value.trim() === "") {
					formValidation[field].isInvalid = true;
					return;
				} else {
					formValidation[field].isInvalid = false;
					return;
				}
		}
	};

    const optionRenderer = (value, options) => {
        if (typeof value === "string") {
            const option = options.find(o => o.id === value);
            if (option) {
                return option.name;
            }
        }
        return value?.name || "";
    }

	return (
		<div className="parent-width">
			{props.state.currentStep == 0 && (
				<div className="parent-width">
					<div>
						<div className="row" style={{ marginTop: -15 }}>
							<DKInput
								title="Employee Name"
								className="mt-xxl"
								required={false}
								type={INPUT_TYPE.TEXT}
								value={`${selectedEmplyee["firstName"]} ${selectedEmplyee["lastName"]}`}
								direction={INPUT_VIEW_DIRECTION.VERTICAL}
								readOnly={true}
							/>
						</div>
					</div>

					{customFieldSectionEnabled && (
						<Fragment>
							<div className="mt-m row justify-content-between align-items-start" style={{ gap: "5%" }}>
								<div style={{ width: "50%" }}>
									<DKInput
										title={"Termination Date"}
										type={INPUT_TYPE.DATE}
										value={detailObj.terminationDate ? moment(detailObj.terminationDate, FORMAT.DDMMYYYY).toDate() : ""}
										direction={INPUT_VIEW_DIRECTION.VERTICAL}
										required={true}
										onChange={(date) => {
											if (new Date(selectedEmplyee.dateOfJoining).getTime() > date.getTime()) {
												formValidation.terminationDate.isInvalid = true;
												formValidation.terminationDate.errorMsg = "Termination date should be gretaer than date of joining";
											} else {
												formValidation.terminationDate.isInvalid = false;
												formValidation.terminationDate.errorMsg = "";
											}

											setDetailObj({
												...detailObj,
												terminationDate: `${moment(date).format(FORMAT.DDMMYYYY)}`,
											});
										}}
									/>
									<div className="mt-xs">
										{formValidation.terminationDate.isInvalid && showError(formValidation.terminationDate.errorMsg)}
									</div>
								</div>
								<div style={{ width: "50%" }}>
									<DKInput
										title="Termination Reason"
										type={INPUT_TYPE.DROPDOWN}
										value={detailObj.terminationReason}
										direction={INPUT_VIEW_DIRECTION.VERTICAL}
										required={true}
                                        renderer={(option) => {
											return optionRenderer(option, TERMINATION_REASONS);
										}}
										dropdownConfig={{
											allowSearch: false,
											searchableKey: "name",
											data: TERMINATION_REASONS,
											renderer: (index, obj) => {
												return <DKLabel text={obj.name} />;
											},
											onSelect: (index, value) => {},
										}}
										onChange={(option) => {
											formValidation.terminationReason.isInvalid = false;
											formValidation.terminationReason.errorMsg = "";

											setDetailObj({
												...detailObj,
												terminationReason: option.id,
											});
										}}
									/>
									{formValidation.terminationReason.isInvalid &&
										<div className="mt-xs">
											{showError(formValidation.terminationReason.errorMsg)}
										</div>
									}
								</div>
							</div>
							<div className="mt-m row justify-content-between align-items-start" style={{ gap: "5%" }}>
								<div style={{ width: "50%" }}>
									<DKInput
										title="Termination Type"
										type={INPUT_TYPE.DROPDOWN}
										value={detailObj.terminationType}
										direction={INPUT_VIEW_DIRECTION.VERTICAL}
										required={true}
										renderer={(option) => {
											return optionRenderer(option, TERMINATION_TYPE);
										}}
										dropdownConfig={{
											allowSearch: false,
											searchableKey: "name",
											data: TERMINATION_TYPE,
											renderer: (index, obj) => {
												return <DKLabel text={obj.name} />;
											},
											onSelect: (index, value) => {},
										}}
										onChange={(option) => {
											setDetailObj({
												...detailObj,
												terminationType: option.id,
											});
										}}
									/>
								</div>
								<div style={{ width: "50%" }}>
									<DKInput
										title="Notice Period (In days)"
										type={INPUT_TYPE.NUMBER}
										value={detailObj.noticePeriod}
										direction={INPUT_VIEW_DIRECTION.VERTICAL}
										required={false}
										onChange={(value) => {
											setDetailObj({
												...detailObj,
												noticePeriod: !isNaN(parseInt(value)) ? parseInt(value) : "",
											});
										}}
									/>
								</div>
							</div>
						</Fragment>
					)}

					{!customFieldSectionEnabled && (
						<div className="mt-l">
							<div className="row" style={{ marginTop: -5 }}>
								<DKInput
									title={"Employee's Last Day"}
									type={INPUT_TYPE.DATE}
									value={detailObj.terminationDate ? moment(detailObj.terminationDate, FORMAT.DDMMYYYY).toDate() : ""}
									direction={INPUT_VIEW_DIRECTION.VERTICAL}
									required={true}
									onChange={(date) => {
										if (new Date(selectedEmplyee.dateOfJoining).getTime() > date.getTime()) {
											formValidation.terminationDate.isInvalid = true;
											formValidation.terminationDate.errorMsg = "Employee's last day should be gretaer than date of joining";
										} else {
											formValidation.terminationDate.isInvalid = false;
											formValidation.terminationDate.errorMsg = "";
										}

										setDetailObj({
											...detailObj,
											terminationDate: `${moment(date).format(FORMAT.DDMMYYYY)}`,
										});
									}}
								/>
							</div>
							<div className="mt-xs">
								{formValidation.terminationDate.isInvalid && showError(formValidation.terminationDate.errorMsg)}
							</div>
						</div>
					)}

					{!customFieldSectionEnabled && (
						<div className="mt-l mb-xl">
							<DKLabel
								text="Did the employee chose to leave?"
								className="text-align-left fw-m mb-s"
							/>
							<div style={{ display: "flex" }}>
								<div className="row" style={{ width: "auto" }}>
									<DKRadioButton
										isSelected={detailObj.terminationType === "VOLUNTARY"}
										color="bg-app"
										onClick={() => {
											setDetailObj({
												...detailObj,
												terminationType: "VOLUNTARY",
											});
										}}
									/>
									<DKLabel className="ml-s mr-l" text={"Voluntary"} />
								</div>

								<div className="row" style={{ width: "auto" }}>
									<DKRadioButton
										isSelected={detailObj.terminationType === "INVOLUNTARY"}
										color="bg-app"
										onClick={() => {
											setDetailObj({
												...detailObj,
												terminationType: "INVOLUNTARY",
											});
										}}
									/>
									<DKLabel className="ml-s mr-l" text={"Involuntary"} />
								</div>
							</div>
						</div>
					)}

					{!customFieldSectionEnabled && (
						<div className="mt-l">
							<div className="align-self-center">
								<div style={{ marginTop: -5 }}>
									<DKInput
										title="Reason For Termination"
										type={INPUT_TYPE.TEXT}
										direction={INPUT_VIEW_DIRECTION.VERTICAL}
										value={detailObj.terminationReason}
										onChange={(value) => {
											onChange(value, "terminationReason");
											setDetailObj({
												...detailObj,
												terminationReason: value,
											});
										}}
									/>
									{formValidation.terminationReason.isInvalid &&
										showError(formValidation.terminationReason.errorMsg)}
								</div>
							</div>
						</div>
					)}

					{customFieldSectionEnabled && (
						<Fragment>
							<div
								className="mt-m row justify-content-between align-items-end"
								style={{ gap: "5%" }}
							>
								<div style={{ width: "50%" }}>
									<DKInput
										title="Exit Interview Feedback"
										type={INPUT_TYPE.DROPDOWN}
										value={detailObj.exitInterviewFeedback}
										direction={INPUT_VIEW_DIRECTION.VERTICAL}
										required={false}
										renderer={(option) => {
											return optionRenderer(option, INTERVIEW_FEEDBACK_OPTIONS);
										}}
										dropdownConfig={{
											allowSearch: false,
											searchableKey: "name",
											data: INTERVIEW_FEEDBACK_OPTIONS,
											renderer: (index, obj) => {
												return <DKLabel text={obj.name} />;
											},
											onSelect: (index, value) => {},
										}}
										onChange={(option) => {
											setDetailObj({
												...detailObj,
												exitInterviewComment: option?.id === "yes" ? detailObj.exitInterviewComment : "",
												exitInterviewFeedback: option.id,
											});
										}}
									/>
								</div>
								<div style={{ width: "50%" }}>
									<DKInput
										title="Clearances From Each Department"
										type={INPUT_TYPE.DROPDOWN}
										value={detailObj.clearanceFromEachDept}
										direction={INPUT_VIEW_DIRECTION.VERTICAL}
										required={false}
										renderer={(option) => {
											return optionRenderer(option, INTERVIEW_FEEDBACK_OPTIONS);
										}}
										dropdownConfig={{
											allowSearch: false,
											searchableKey: "name",
											data: INTERVIEW_FEEDBACK_OPTIONS,
											renderer: (index, obj) => {
												return <DKLabel text={obj.name} />;
											},
											onSelect: (index, value) => {},
										}}
										onChange={(option) => {
											setDetailObj({
												...detailObj,
												clearanceFromEachDept: option.id,
											});
										}}
									/>
								</div>
							</div>
							<div className="mt-m">
								<DKInput
									title="Exit Interview Comments"
									type={INPUT_TYPE.LONG_TEXT}
									value={detailObj.exitInterviewComment}
									direction={INPUT_VIEW_DIRECTION.VERTICAL}
									required={false}
									readOnly={!detailObj.exitInterviewFeedback || detailObj.exitInterviewFeedback !== "yes"}
									onChange={(value) => {
										setDetailObj({
											...detailObj,
											exitInterviewComment: value,
										});
									}}
								/>
							</div>
						</Fragment>
					)}

					<div className="mt-l mb-xl">
						<div className="" style={{ marginTop: -5 }}>
							<DKInput
								title="Personal Email Address"
								type={INPUT_TYPE.TEXT}
								direction={INPUT_VIEW_DIRECTION.VERTICAL}
								required
								value={detailObj.employeePersonalEmail}
								onChange={(value) => {
									onChange(value, "employeePersonalEmail");
									setDetailObj({
										...detailObj,
										employeePersonalEmail: value,
									});
								}}
							/>
							{formValidation.employeePersonalEmail.isInvalid &&
								showError(formValidation.employeePersonalEmail.errorMsg)}
						</div>
					</div>
				</div>
			)}
			{props.state.currentStep == 1 && (
				<div>
					<div className="mb-l mt-xxl">
						<DKLabel text={customFieldSectionEnabled ? "Termination date of the employee" : "Last day of the employee"} className="text-align-left" />
						<DKLabel
							text={prevStateData.terminationDate}
							className="text-align-left fw-m bg-gray1 border-radius-s mt-s p-r border-box"
						/>
					</div>
					{!customFieldSectionEnabled &&
						<div className="mb-l">
							<DKLabel text="Last Pay Stub" className="text-align-left" />
							<DKLabel
								text="You can run an Ad-hoc pay run or process for the employee or next scheduled pay run"
								className="text-align-left fw-m bg-gray1 border-radius-s mt-xs p-l border-box"
							/>
						</div>
					}
					<div>
						<DKLabel text="Off-Boarding Checklist" className="text-align-left fw-m" />
						<div
							className="column justify-content-center align-items-center  border-radius-s mt-m border-box parent-width"
							styele={{ marginTop: -9 }}
						>
							{showCheckList()}
						</div>
					</div>
					<div>
						<DKButton
							title="+ Task"
							className="border-m bg-app text-white mb-xl"
							style={{ width: 63 }}
							onClick={(event) => {
								addChecklist();
							}}
						/>
					</div>
				</div>
			)}
		</div>
	);
};

export default EmployteeTermination;
